module.exports = __webpack_public_path__ + "static/media/favicon.d7bf765f.png";